// Why: server returns media URLs in two shapes — `/api/audio/X` (exam routes,
// host-rooted, broke when the SPA stopped being same-origin with the API) and
// `/audio/X` (woorden, api-rooted). This resolver normalizes both against
// VITE_API_URL and is a no-op for already-absolute URLs.

const API = (import.meta.env.VITE_API_URL ?? "/api") as string;
const API_ORIGIN = API.startsWith("http") ? new URL(API).origin : "";

export function resolveMediaUrl(url: string | null | undefined): string {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${API_ORIGIN}${url}`;
  return `${API}${url}`;
}
